import { Update } from "../components/rate-adjustment-case/Update";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/* 
  料率調整案件更新画面
 */
const ApplicationItemDefinitionsUpdate = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.RATE_SETTING);

  return (
    <SpaceBetween size="l">
      <Update />
    </SpaceBetween>
  );
};

export default ApplicationItemDefinitionsUpdate;
